<template>
    <PageContainer>
        <PageHeader>
            {{ $t('user.edit.page_title') }}
        </PageHeader>

        <form
            enctype="application/x-www-form-urlencoded"
            autocomplete="off"
            @submit.prevent="onSubmit"
            class="row"
        >
            <!-- name -->
            <div class="col-12 col-md-6">
                <div class="form-group mb-3">
                    <label for="name">
                        {{ $t('user.name') }}
                    </label>
                    <input
                        type="text"
                        id="name"
                        class="form-control"
                        :class="[form.errors.name ? 'is-invalid' : '']"
                        autocomplete="name"
                        autofocus
                        v-model="form.name"
                        :placeholder="$t('user.name')"
                    >
                    <form-error v-if="form.errors.name">
                        {{ form.errors.name }}
                    </form-error>
                </div>
            </div>

            <!-- email -->
            <div class="col-12 col-md-6">
                <div class="form-group mb-3">
                    <label for="email">
                        {{ $t('user.email') }}
                    </label>
                    <input
                        type="email"
                        id="email"
                        class="form-control"
                        :class="[form.errors.email ? 'is-invalid' : '']"
                        v-model="form.email"
                        :placeholder="$t('user.email')"
                    >
                    <form-error v-if="form.errors.email">
                        {{ form.errors.email }}
                    </form-error>
                </div>
            </div>

            <!-- password -->
            <div class="col-12 col-md-6">
                <div class="form-group mb-3">
                    <label for="password">
                        {{ $t('user.password') }}
                    </label>
                    <input
                        type="password"
                        id="password"
                        class="form-control"
                        :class="[form.errors.password ? 'is-invalid' : '']"
                        v-model="form.password"
                        :placeholder="$t('user.password')"
                    >
                    <form-error v-if="form.errors.password">
                        {{ form.errors.password }}
                    </form-error>
                </div>
            </div>

            <!-- confirm_password -->
            <div class="col-12 col-md-6">
                <div class="form-group mb-3">
                    <label for="password_confirmation">
                        {{ $t('user.password_confirmation') }}
                    </label>
                    <input
                        type="password"
                        id="password_confirmation"
                        class="form-control"
                        :class="[form.errors.password_confirmation ? 'is-invalid' : '']"
                        v-model="form.password_confirmation"
                        :placeholder="$t('user.password_confirmation')"
                    >
                    <form-error v-if="form.errors.password_confirmation">
                        {{ form.errors.password_confirmation }}
                    </form-error>
                </div>
            </div>

            <!-- role -->
            <div class="col-12 col-md-6">
                <div class="form-group mb-3">
                    <label for="role">
                        {{ $t('user.role') }}
                    </label>
                    <select v-model="form.role" class="form-select">
                        <option v-for="role in roles" :value="role">{{ role }}</option>
                    </select>
                    <form-error v-if="form.errors.password_confirmation">
                        {{ form.errors.password_confirmation }}
                    </form-error>
                </div>
            </div>

            <FormActionContainer class="col-12">
                <BackButton href="/users" />
                <SubmitButton />
            </FormActionContainer>
        </form>
    </PageContainer>
</template>

<script setup lang="ts">
import {useForm} from "@inertiajs/vue3";
import FormError from "@/components/elements/FormError.vue";
import SubmitButton from "@/components/buttons/SubmitButton.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import type {UserInterface} from "@/components/helpers/Interfaces.ts";
import PageContainer from "@/components/elements/PageContainer.vue";
import PageHeader from "@/components/elements/PageHeader.vue";
import FormActionContainer from "@/components/elements/FormActionContainer.vue";

const {roles, user} = defineProps<{
    roles: string[],
    user: UserInterface
}>()

const form = useForm({
    name: user.name,
    email: user.email,
    password: null,
    password_confirmation: null,
    role: user.role
})

const onSubmit = () => {
    form.put('/users/'+user.id)
}
</script>

<style scoped>

</style>
